import axios from '../script/axiosAMS'

export default {
  getModemAS (params, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem/as',
      method: 'get',
      params: params,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  modemAS (method, data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/as',
      method: method,
      data: data,
      resultCallback: resultCallback
    })
  },
  bulkInsertModemAS (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem/as',
      method: 'put',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  bulkUpdateModemAS (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem/as',
      method: 'post',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  reqToAcc (data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/as/reqToAcc',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  accToProc (data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/as/accToProc',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  },
  procToFin (data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/as/procToFin',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/modemAS.js